import { render, staticRenderFns } from "./GDQAdmin.vue?vue&type=template&id=2b694622&"
import script from "./GDQAdmin.vue?vue&type=script&lang=js&"
export * from "./GDQAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports